import { Icon } from "components";
import { cn } from "utils";
import { CONTRACT } from "icons";
import { useSidebar } from "ui/components/sidebar";
import { ShimmerEffect } from "@/components/shimmer";
import { StatusDisplay } from "@/components/status/display";
import { TypeDisplay } from "@/components/type/display";

/**
 * A collapsible contract header component that adapts to sidebar state
 * Shows full header when expanded, only logo when collapsed
 * @param {Object} props - Component props
 * @param {Object} props.contract - The contract data object
 * @param {string} props.contract.status - Contract status
 * @param {string} props.contract.type - Contract type
 * @param {boolean} props.isLoading - Whether the contract data is loading
 * @param {string} props.className - Additional CSS classes
 */

export function CollapsibleContractHeader({ contract, isLoading = false, className = "" }) {
  const { state } = useSidebar();
  const isCollapsed = state === "collapsed";

  if (isLoading) {
    return (
      <div className="flex items-center gap-2">
        <ShimmerEffect className="w-30 h-5" />
        <ShimmerEffect className="w-20 h-5" />
      </div>
    );
  }

  if (!contract) {
    return null;
  }

  return (
    <div className={cn(className)}>
      {isCollapsed ? (
        <div className="flex items-center gap-2">
          <Icon icon={CONTRACT} size={10} />
        </div>
      ) : (
        <div className="flex items-center gap-2">
          <StatusDisplay value={contract.status} />
          <TypeDisplay value={contract.type} />
        </div>
      )}
    </div>
  );
}
